import React from "react";
import {
  getExtensionPageLabel,
  isExtensionEditorSurfacePreview,
} from "../../../shared/extension-preview.js";
import styles from "./checkout-extension-preview.module.css";

/**
 * Common editor preview shell for all Shopify checkout extension surfaces.
 */
const CheckoutExtensionPreviewLayout = ({
  surface,
  isMobile = false,
  children,
  variant = "default",
}) => {
  const pageLabel = getExtensionPageLabel(surface);
  const isSurfaceLayout =
    variant === "surface" || isExtensionEditorSurfacePreview(surface);

  return (
    <div
      className={`${styles.root} ${isSurfaceLayout ? styles.rootSurface : ""}`.trim()}
      data-extension-surface={surface || ""}
      data-mobile={isMobile ? "1" : "0"}
    >
      <div
        className={`${styles.chrome} ${isSurfaceLayout ? styles.chromeSurface : ""}`.trim()}
      >
        {!isSurfaceLayout ? (
          <div className={styles.pageBadge}>{pageLabel}</div>
        ) : null}
        <div
          className={`${styles.contentSlot} ${
            isSurfaceLayout ? styles.contentSlotSurface : ""
          }`.trim()}
        >
          <div className={styles.contentSlotInner}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutExtensionPreviewLayout;
